<script setup>
import Close from '@/assets/icons/close.svg'
import Check from '@/assets/icons/check.svg'

const props = defineProps({
    formToggleSwitchConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                id: value => value.id === undefined || typeof value.id === 'string',
                name: value => value.name === undefined || typeof value.name === 'string',
                val: value => value.val === undefined || typeof value.val === 'string'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

const checkedNames = computed(() => {
    return props.formToggleSwitchConfig.val ? [props.formToggleSwitchConfig.val] : []
})

const emit = defineEmits(['update:updateValue'])
</script>

<template>
    <label :for="formToggleSwitchConfig.id" class="form-toggle-switch">
        <input
            :id="formToggleSwitchConfig.id"
            v-model="checkedNames"
            class="form-toggle-switch-input"
            type="checkbox"
            :value="formToggleSwitchConfig.val"
            :name="formToggleSwitchConfig.name"
            @input="emit('update:updateValue', $event.target.checked)"
        >
        <span class="form-toggle-switch-button">
            <Check class="form-toggle-switch-icon-checked" />
            <Close class="form-toggle-switch-icon-unchecked" />
        </span>
    </label>
</template>

<style lang="scss">
.form-toggle-switch {
    position: relative;
    width: 48px;
    height: 26px;
    display: inline-block;
}

.form-toggle-switch-button {
    position: absolute;
    background: $form-toggle-switch-bg;
    border-radius: 17px;
    cursor: pointer;
    inset: 0;
    transition: background 400ms ease-in-out;

    &::before {
        background-color: white;
        border-radius: 50%;
        content: "";
        position: absolute;
        left: 2px;
        top: 2px;
        height: 22px;
        width: 22px;
        transition: transform 400ms ease-in-out
    }
}

.form-toggle-switch-icon-checked,
.form-toggle-switch-icon-unchecked {
    position: absolute;
    transition: transform 400ms ease-in-out, opacity 400ms ease-in-out;
    left: 8px;
    top: 9px;
}

.form-toggle-switch-icon-checked {
    opacity: 0;
    width: 12px;
}

.form-toggle-switch-icon-unchecked {
    width: 9px;
}

.form-toggle-switch-label {
    @include helper-text;
}

.form-toggle-switch-input {
    display: none;

    &:checked {
        + .form-toggle-switch-button {
            background: $form-toggle-switch-active-bg;

            &::before {
                transform: translateX(22px);
            }

            .form-toggle-switch-icon-unchecked {
                transform: translateX(22px);
                opacity: 0;
            }

            .form-toggle-switch-icon-checked {
                transform: translateX(22px);
                opacity: 1;
            }
        }
    }
}
</style>
